module.exports = __webpack_public_path__ + "icon_close_blue.a364d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_close_blue.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_close_blue.svg
// module chunks = main